// делим массив на две части так, чтобы во второй половине было на один объект больше.
export function splitArray(array) {
    const middle = Math.floor(array.length / 2);
    return [array.slice(0, middle), array.slice(middle)];
}